import { render, staticRenderFns } from "./CapitalsTable.vue?vue&type=template&id=8ee2c6e0&scoped=true&"
import script from "./CapitalsTable.vue?vue&type=script&lang=js&"
export * from "./CapitalsTable.vue?vue&type=script&lang=js&"
import style0 from "./CapitalsTable.vue?vue&type=style&index=0&id=8ee2c6e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ee2c6e0",
  null
  
)

export default component.exports